import { Mail } from "lucide-react";
import { openContactModal } from "@/components/ContactModal";

/**
 * "Email us" button — opens the inline ContactModal directly on our site.
 *
 * Replaces the old <a href="mailto:"> behaviour which on desktop simply
 * showed a "copy and paste into your email app" toast (terrible UX — most
 * clients won't bother). Now clicking lands them in a 4-field form and we
 * receive their message as a normal email with reply-to set to them.
 *
 * Props kept for API compatibility with existing call sites, but `email`,
 * `subject` and `body` are now informational only (no mailto is fired).
 */
export default function SupportEmailButton({
  email,        // eslint-disable-line no-unused-vars
  subject = "", // eslint-disable-line no-unused-vars
  body = "",    // eslint-disable-line no-unused-vars
  label,
  className = "",
  variant = "ghost",
  source = "support-email-button",
  "data-testid": testId = "support-email-btn",
}) {
  const baseClass =
    "inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold transition-colors";
  const variantClass =
    variant === "amber"
      ? "bg-amber-500/15 hover:bg-amber-500/25 border border-amber-500/30 text-amber-300"
      : "bg-zinc-700/50 hover:bg-zinc-700 border border-zinc-600/50 text-zinc-200";

  return (
    <button
      type="button"
      onClick={() => openContactModal({ source })}
      data-testid={testId}
      className={`${baseClass} ${variantClass} ${className}`}
    >
      <Mail className="w-3.5 h-3.5" />
      <span>{label || "Message us"}</span>
    </button>
  );
}
